/**
 * @generated SignedSource<<cb5b8bcf5a43bd0b879ff940dd6f8aee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventCreateInput = {
  happenedAt: any;
  jobId: string;
  typeEventId: string;
};
export type EventCardCreateMutation$variables = {
  input: EventCreateInput;
};
export type EventCardCreateMutation$data = {
  readonly createEvent: {
    readonly node: {
      readonly happenedAt: any | null | undefined;
      readonly id: string;
      readonly type: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type EventCardCreateMutation = {
  response: EventCardCreateMutation$data;
  variables: EventCardCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EventEdge",
    "kind": "LinkedField",
    "name": "createEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "happenedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventType",
            "kind": "LinkedField",
            "name": "type",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventCardCreateMutation",
    "selections": (v2/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventCardCreateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9b8fcca5cb4b35eaeb522548ab84db9d",
    "id": null,
    "metadata": {},
    "name": "EventCardCreateMutation",
    "operationKind": "mutation",
    "text": "mutation EventCardCreateMutation(\n  $input: EventCreateInput!\n) {\n  createEvent(input: $input) {\n    node {\n      id\n      happenedAt\n      type {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "be84b8c2f0ed8f5769124c07e9cd161e";

export default node;
